import { useState } from "react";
import validateEmail from "../../../../utility/validator/email-validation";
import validatePhoneNumber from "../../../../utility/validator/phone-no-validation";
import dataProvider from "../../../../services/dataProvider";
import { Link } from "react-router-dom";
import { TERMS_AND_CONDITIONS } from "../../../../routes";

const ContactForm = () => {
    var baseState = {
        email:"",
        name:"",
        phone_number:"",
        license_number:""
    }
    const [alertForm, setAlertForm] = useState(baseState)
    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [termsAgreed, setTermsAgreed] = useState(false);

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    var handleSubmit = (e) =>{
        e.preventDefault();
        setIsLoading(true);
        setShowErrorMessage("")
        //console.log(alertForm);

        if(!validateEmail(alertForm.email)){
            setShowErrorMessage("Please Enter a valid email");
            setEmailError(true);
            setIsLoading(false);
            return false ;
        } else {
            setEmailError(false);
        }

        if(!validatePhoneNumber(alertForm.phone_number)){
            setShowErrorMessage("Please Enter a Valid phone number");
            setPhoneError(true);
            setIsLoading(false);
            return false ;
        } else {
            setPhoneError(false);
        }


        fetch(dataProvider.baseUrl+"alertForm",{method:"POST",body: JSON.stringify(alertForm)})
        .then(res => res.json())
        .then(result => {
            //console.log("result",result);
            if(result.status === "success")
            {
                setAlertForm(baseState)
                setShowSuccessMessage(true);
                setShowErrorMessage("");
            } else {
                console.error("error",result);
                setShowErrorMessage("Something went wrong");
                setShowSuccessMessage(false);
            }
            setIsLoading(false);
        }).catch((err)=>{
            console.error("error",err);
            setShowErrorMessage(err.message);
            setShowSuccessMessage(false);
            setIsLoading(false);
        })
    }

    return (
        <div
            className="card shadow bg-light p-4"
            style={{
                borderRadius: "1rem",
                maxWidth: "32rem",
            }}
        >
            <h1 className="card-title h2 text-center text-secondary">
                Subscribe for <br /> FREE Alerts
            </h1>

            {
                showSuccessMessage && (
                    <div className="alert alert-success" role="alert">
                        You have successfully subscribed to iComply's Free Alerts!
                    </div>
                )
            }

            {
                showErrorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {showErrorMessage}
                    </div>
                )
            }

            {/* <p className="text-center text-black-50">Lorem ipsum dolor sit.</p> */}
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className="mb-3">
                    <input
                        value = {alertForm.name}
                        onChange={(e)=>{setAlertForm({...alertForm,name:e.target.value});}}
                        style={{ height: "3rem" }}
                        className="border form-control ui-3 text-3"
                        type="text"
                        placeholder="Your Name"
                        required
                    />
                </div>
                <div className="mb-3">
                    <input
                        onChange={(e) => {
                            setAlertForm({...alertForm,email:e.target.value});
                        }}
                        onBlur={(e) => {
                            if(!validateEmail(e.target.value)) {
                                setEmailError(true) ;
                            } else {
                                setEmailError(false) ;
                            }
                        }}
                        value={alertForm.email} 
                        style={{ height: "3rem" }}
                        className={"border form-control ui-3 text-3 " + (emailError ? "is-invalid" : "")} 
                        type="email"
                        placeholder="Prefered Email"
                        required
                    />
                    {emailError && (
                        <div className=" text-danger">
                            Invalid Email Address
                        </div>
                    )}
                </div>
                <div className="mb-3">
                    <input
                        onChange={(e) => {
                            setAlertForm({...alertForm,phone_number:e.target.value});
                        }}
                        onBlur={(e) => {
                            if(!validatePhoneNumber(e.target.value)) {
                                setPhoneError(true) ;
                            } else {
                                setPhoneError(false) ;
                            }
                        }}
                        value={alertForm.phone_number} 
                        style={{ height: "3rem" }}
                        className={"border form-control ui-3 text-3 " + (phoneError ? "is-invalid" : "")}
                        type="text"
                        placeholder="Phone Number"
                        required
                    />
                    {phoneError && (
                        <div className="text-danger">
                            Invalid Phone Number
                        </div>
                    )}
                </div>
                <div className="mb-3">
                    <input
                        value={alertForm.license_number} 
                        onChange={(e)=>{setAlertForm({...alertForm,license_number:e.target.value})}} 
                        style={{ height: "3rem" }}
                        className="border form-control ui-3 text-3"
                        type="text"
                        aria-placeholder="License Number"
                        placeholder="Realestate License Number"
                        required
                    />
                </div>
                <div className="mb-3">
                    <a target="_blank" href="https://www.onegov.nsw.gov.au/publicregister/#/publicregister/search/Property">
                        <button
                            type="button"
                            style={{ height: "3rem" }}
                            className="btn btn-outline-primary w-100 rounded-pill"
                        >
                            Find Your License Number
                        </button>
                    </a>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        onChange={(e) => setTermsAgreed(e.target.checked)}
                        value=""
                        required
                    />
                    <label
                        className="form-check-label ms-3"
                        htmlFor="flexCheckDefault"
                    >
                        I agree to{" "}
                        <a className="link" target="_blank" href={TERMS_AND_CONDITIONS}>terms of services</a>
                    </label>
                </div>

                <div className="">
                    {
                        isLoading ? (   
                            <button
                                style={{ height: "3rem" }}
                                className="d-flex align-items-center justify-content-center btn btn-primary w-100 rounded-pill text-light"
                                disabled={true}
                            >
                                Subscribing...

                                <div className="spinner-border ms-4" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </button>

                        ) : (
                        <button
                            style={{ height: "3rem" }}
                            className="btn btn-primary w-100 rounded-pill text-light"
                            disabled={(!termsAgreed) && (!phoneError) && (!emailError)}
                        >
                            Subscribe
                        </button>
                        ) 
                    }
                    
                </div>
            </form>
        </div>
    );
};

export default ContactForm;
